import React from 'react'
import { BsCart4 } from 'react-icons/bs'
import { FaChevronRight } from 'react-icons/fa6'

const PlaceButton = ({ selectedType,handlePlaceOrder, isCheckout, cartItems, handleConfirmOrder, editing }) => {

  return (
    <>
      {cartItems.length > 0 && !isCheckout && (
        <div className="palceOrder-Bottom">
          <div className="cart-quantity">
            <div>
              <BsCart4 className="" fontSize={21} />
            </div>
            <div>
              <p className="item">{cartItems.length} Product</p>
            </div>
          </div>
          <div className="placeorderbtn">
            <button onClick={handlePlaceOrder}>
              Place Items{" "}
              <span>
                <FaChevronRight size={16} className="RightIcon" color="white" />
              </span>
            </button>
          </div>
        </div>
      )}
      {(cartItems.length > 0 && (isCheckout || editing) &&
        <div className="palceOrder-Bottom checkout-bottom">
          <div className="cart-quantity checkout-quantity">
            <BsCart4 className="" fontSize={24} />
            {cartItems.length} Product
          </div>
          <div className="placeorderbtn checkoutbtn">
            <button
              onClick={() =>
                handleConfirmOrder(
                  editing && selectedType === "SQ"
                    ? "Update Quotation"
                    : editing && selectedType === "SO"
                      ? "Update Order"
                      : !editing && !selectedType
                        ? "Confirm"
                        : ""
                )
              }
            >
              {editing && selectedType === "SQ"
                ? "Update Quotation"
                : editing && selectedType === "SO"
                  ? "Update Order"
                  : !editing && !selectedType
                    ? "Confirm"
                    : ""}
            </button>
          </div>
        </div>
      )}

    </>
  )
}

export default PlaceButton
